import { AlertTriangle, Info } from 'lucide-react';

import { FileUpload } from '@/components/file-upload/FileUpload';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

import { useQrContext } from '../state/qr-context';

/** Above this share of the symbol, only level H reliably survives the cut-out. */
const SAFE_LOGO_PERCENT = 30;

export function LogoSettings() {
  const { design, actions } = useQrContext();
  const isRisky = design.centerImageSize > SAFE_LOGO_PERCENT && design.errorCorrectionLevel !== 'H';

  return (
    <div className="space-y-4">
      <FileUpload
        label="Logo in der Mitte"
        selectedFile={design.centerImage}
        onSelect={actions.setCenterImage}
        onRemove={() => {
          actions.setCenterImage(null);
        }}
      />

      {design.centerImage !== null && (
        <>
          <div className="space-y-2">
            <div className="flex items-baseline justify-between">
              <Label htmlFor="logo-size">Logo-Größe</Label>
              <span className="text-sm tabular-nums text-muted-foreground">
                {design.centerImageSize} %
              </span>
            </div>
            <Slider
              id="logo-size"
              value={[design.centerImageSize]}
              min={10}
              max={40}
              step={1}
              onValueChange={([next]) => {
                if (next !== undefined) actions.setCenterImageSize(next);
              }}
            />
          </div>

          {isRisky ? (
            <Alert variant="warning">
              <AlertTriangle aria-hidden="true" />
              <AlertDescription>
                Bei über {SAFE_LOGO_PERCENT} % Logo-Größe solltest du die Fehlerkorrektur auf „Hoch
                (30 %)“ stellen — sonst fehlen dem Code zu viele Daten.
              </AlertDescription>
            </Alert>
          ) : (
            <Alert variant="info">
              <Info aria-hidden="true" />
              <AlertDescription>
                Die Module hinter dem Logo werden ausgespart. Bis {SAFE_LOGO_PERCENT} % bleibt der
                Code bei hoher Fehlerkorrektur zuverlässig lesbar.
              </AlertDescription>
            </Alert>
          )}
        </>
      )}
    </div>
  );
}
